import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import useHandleErrors from '../../../hooks/useHandleErrors';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import { InvoiceService } from '../../../services/invoice/invoiceService';
import NonStandardInvoiceForm from './NonStandardInvoiceForm';

const breadCrumb = [
    { name: 'Ventas' },
    { name: 'Gestión de contratos' },
    { name: 'Facturas', href: menuRoutes.invoices.path },
    { name: 'Nueva factura atípica' },
];

const NonStandardInvoiceCreate: React.FC = () => {
    const navigate = useNavigate();
    const { handleErrors } = useHandleErrors();
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (values: any) => {
        setIsLoading(true);
        try {
            const service = new InvoiceService();
            const response = await service.createInvoice({
                invoiceType: 'non_standard_invoice',
                corporationId: values.corporationId,
                paymentMethodId: values.paymentMethodId,
                invoiceDate: values.invoiceDate,
                expirationDate: values.expirationDate,
                paymentDate: values.paymentDate || null,
                receiverType: values.receiverType,
                clientId: values.clientId || null,
                providingCorporationId: values.providingCorporationId || null,
                externalClientName: values.externalClientName || null,
                externalClientNif: values.externalClientNif || null,
                externalClientAddress: values.externalClientAddress || null,
                externalClientProvince: values.externalClientProvince || null,
                externalClientLocality: values.externalClientLocality || null,
                externalClientPostalCode: values.externalClientPostalCode || null,
                externalClientContact: values.externalClientContact || null,
                tax: values.tax,
                irpf: values.irpf || null,
                irc: values.irc || null,
                ivaExempt: values.ivaExempt,
                taxableAmount: values.taxableAmount,
                totalTaxesAmount: values.totalTaxesAmount,
                totalPrice: values.totalPrice,
                totalProducts: values.totalProducts || null,
                lines: values.lines,
            });

            const responseData = response.getResponseData();

            if (responseData?.success) {
                toast.success('Factura atípica creada correctamente');
                navigate(menuRoutes.invoices.path);
            } else {
                toast.error(responseData?.message || 'Error al crear la factura');
            }
        } catch (error) {
            handleErrors(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Fragment>
            <PageHeader title="Nueva factura atípica" breadcrumb={breadCrumb} />
            <NonStandardInvoiceForm isLoading={isLoading} submit={handleSubmit} />
        </Fragment>
    );
};

export default NonStandardInvoiceCreate;
